// ロール定数（正本: docs/refactor-constants.md / rolesテーブル）

// ロールID
export const ROLE_IDS = {
  ADMIN: 1,
  MEMBER: 2,
} as const;

export type RoleId = (typeof ROLE_IDS)[keyof typeof ROLE_IDS];

// ロール表示名
export const ROLE_NAMES = {
  [ROLE_IDS.ADMIN]: '管理者',
  [ROLE_IDS.MEMBER]: 'メンバー',
} as const;
